import { render, staticRenderFns } from "./nuxt-picture.vue?vue&type=template&id=310bdcc2"
import script from "./nuxt-picture.vue?vue&type=script&lang=js"
export * from "./nuxt-picture.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports